module.exports = __webpack_public_path__ + "img/Rendering RZ Rückseite 20.08.2009.19be5428.jpg";